module.exports = __webpack_public_path__ + "static/media/gy.d25561ff.svg";